import { useRouter } from 'next/router';
import { useContext } from 'react';
import { CartIcon } from 'src/components/shared/elements/icons/CartIcon';
import { FAQIcon } from 'src/components/shared/elements/icons/FAQIcon';
import { InfoIcon } from 'src/components/shared/elements/icons/InfoIcon/Index';
import { LocationSignIcon } from 'src/components/shared/elements/icons/LocationSignIcon';
import { SearchIcon } from 'src/components/shared/elements/icons/SearchIcon';
import { KaimonoWebRoutes } from 'src/config/routes';
import { CLOUD_FRONT_IMAGE_PATH } from 'src/constants/imagePath';
import { useCart } from 'src/hooks/useCart';
import { useOverlay } from 'src/hooks/useOverlay';
import { useScrollDirection } from 'src/hooks/useScrollDirection';
import { I18nContext } from 'src/stores/I18n';
import { mixpanel } from 'src/utils/mixpanel';
import { Presenter } from './Presenter';

export const BottomMenu: React.FC = () => {
  const localeResources = useContext(I18nContext);
  const isDown = useScrollDirection();
  const { cart } = useCart();
  const cartLineCount = cart?.reduce((a, b) => a + b.quantity, 0) ?? 0;
  const pathname = useRouter().pathname;
  const { setIsOverlayVisible } = useOverlay();
  const handleOnSearchOverlay = () => {
    setIsOverlayVisible(true);
    mixpanel.onBottomMenuTapped('search');
  };

  const BOTTOM_MENU_HIDDEN_PATHS = [KaimonoWebRoutes.cart, '/order/'];
  const isBottomMenuHiddenPage = BOTTOM_MENU_HIDDEN_PATHS.some((path) => pathname.includes(path));

  const bottomMenuItems = [
    {
      route: KaimonoWebRoutes.index,
      imageSrc: `${CLOUD_FRONT_IMAGE_PATH}/common/wamazing.webp`,
      title: 'TOP',
      event: 'top'
    },
    {
      route: '#',
      iconComponent: <SearchIcon width={24} height={24} />,
      title: localeResources.search.search,
      event: 'search',
      onClick: handleOnSearchOverlay
    },
    {
      route: KaimonoWebRoutes.walkthrough,
      iconComponent: <InfoIcon />,
      title: localeResources.staticWalkthrough.title,
      event: 'walkthrough'
    },
    {
      route: KaimonoWebRoutes.customerSupport,
      iconComponent: <FAQIcon />,
      title: localeResources.customerSupport.title,
      event: 'support'
    },
    {
      route: KaimonoWebRoutes.guide,
      iconComponent: <LocationSignIcon />,
      title: localeResources.guide.title,
      event: 'guide'
    },
    {
      route: KaimonoWebRoutes.cart,
      iconComponent: <CartIcon color="#2F353E" type="secondary" />,
      title: localeResources.cart.title,
      event: 'cart',
      badge: cartLineCount ? String(cartLineCount) : ''
    }
  ];

  if (isBottomMenuHiddenPage) {
    return null;
  }

  return <Presenter isDown={isDown} bottomMenuItems={bottomMenuItems} />;
};
